import Core from "@/modules/core/service/Core";

const url = {
    state: "/api/incident/unit/{0}/maintenance/{1}",
    list : "/api/incident/unit/{0}/maintenance",
}

export default {
    state (unitId) {
        const today = new Date ();
        return Core.method.get(url.state, unitId, today.getFullYear());
    },

    list (unitId) {
        return Core.method.get(url.list, unitId);
    }
}